import { ActivityItem } from './notificationMapper';

/**
 * One row of Inbox → Communication → Alerts.
 *
 * Alerts shows the same items as the bell's Recent Notifications - both read
 * useParentFeed (feed items, email/push receipts, live messages). It used to call the
 * feed on its own and keep only URGENT/HIGH/EMERGENCY items, so a parent saw two CXC
 * notifications under the bell and "No alerts" here (QA).
 */
export interface AlertRow {
  id: string;
  title: string;
  description: string;
  /** The same badge text the bell shows ("Cxc", "Payment", "Emergency" ...). */
  label: string;
  color: string;
  date: string;
}

const EMERGENCY_COLOR = '#DC2626';
const DEFAULT_COLOR = '#3B82F6';

export function alertRowFrom(item: ActivityItem): AlertRow {
  return {
    id: item.id,
    title: item.name || 'Alert',
    description: item.details || '',
    label: item.badge?.text || 'Alert',
    color: item.category === 'EMERGENCY' ? EMERGENCY_COLOR : item.badge?.color || DEFAULT_COLOR,
    date: item.createdAt,
  };
}
